import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import { checkRedirect, initSdk } from 'wecom-sidebar-jssdk';
import config from '@/config';
import { fetchSignatures, fetchUserId } from '@/api';
import 'ant-design-vue/dist/antd.css';
import { mockSdk } from '@/mock';
// 自动 Mock
mockSdk();
//获取Url 中的 corpId 跟 agentId  
let corpIdParam = null;
let agentIdParam = null;
try {
    const currentUrl = new URL(window.location.href);
    corpIdParam = currentUrl.searchParams.get('corpId');
    agentIdParam = currentUrl.searchParams.get('agentId');
}
catch (e) {
    // ignore
}
// 兼容 hash 路由中的查询参数（/#/path?corpId=xxx&agentId=yyy）
if ((!corpIdParam || !agentIdParam) && window.location.hash) {
    const hash = window.location.hash;
    const qIndex = hash.indexOf('?');
    if (qIndex !== -1) {
        const hashQuery = hash.slice(qIndex + 1);
        const hashParams = new URLSearchParams(hashQuery);
        if (!corpIdParam)
            corpIdParam = hashParams.get('corpId');
        if (!agentIdParam)
            agentIdParam = hashParams.get('agentId');
    }
}
if (corpIdParam && agentIdParam) {
    config.corpId = corpIdParam;
    config.agentId = agentIdParam;
}
Vue.config.productionTip = false;
console.log(config);
checkRedirect(config, fetchUserId) // 重定向获取 code（用户身份）
    .then(() => initSdk(config, fetchSignatures)) // 初始化 JsSdk
    .then(() => {
    new Vue({
        router,
        store,
        render: h => h(App)
    }).$mount('#app');
});
